import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CompanyService } from '../../Utils/_services/company/company.service';
import { ToastrService } from 'ngx-toastr';
import { IContactUs_AppNameOptions, IContactUs_AppPriceRange, IContactUs_ContactInfo, IContactUs_FormData, IContactUs_SocialLinks, IContactUs_SubjectOptions } from './contact.model';
import { ICustomError } from '../../Utils/_models/network-response';
import { AppManagementService } from '../../Utils/_services/app-management/app-management.service';
import { IAppManagementEntityDto } from '../../Utils/_services/app-management/app-management.model';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent {

  formData: IContactUs_FormData = {
    fullName: "",
    email: "",
    subject: 1,
    message: "",
  }

  isSubmitting = false;
  showSuccessMessage = false;
  showErrorMessage = false;
  failedMsg: string = "";
  minDate: string = "";
  maxDate : string = "";
  appManagement: IAppManagementEntityDto[] = [];

  // Contact information
  contactInfo: IContactUs_ContactInfo = {
    address: "123 Business Street, Suite 100, City, State 12345",
    phone: "+1 (555) 123-4567",
    email: "business@insizon.com",
    hours: "Mon - Fri: 9:00 AM - 6:00 PM",
  }

  // Social media links
  socialLinks: Array<IContactUs_SocialLinks> = [
    { icon: "pi pi-facebook", url: "#", label: "Facebook" },
    { icon: "pi pi-twitter", url: "#", label: "Twitter" },
    { icon: "pi pi-linkedin", url: "#", label: "LinkedIn" },
    { icon: "pi pi-instagram", url: "#", label: "Instagram" },
  ]

  // Contact reasons/subjects
  public contactReasons: Array<IContactUs_SubjectOptions> = [
    { Id: 1, Name: "General Inquiry / Question", Priority: 1},
    { Id: 2, Name: "Customer Support / Technical Issue", Priority: 1},
    { Id: 3, Name: "Billing / Invoice Question", Priority: 3},
    { Id: 4, Name: "Feedback / Suggestion", Priority: 1},
    { Id: 5, Name: "Report a Bug / Website Problem", Priority: 1},
    { Id: 6, Name: "Careers / Job Opportunities", Priority: 1},
    // TODO: Add logic where all buyers has to first
    // Pay meeting fee of $100 via stripe/paypal
    // Sign 2 yr NDA - to protect sensitive data like financials, IP, and customer lists
    // Buyer must make an offer >= $250,000. Split 10% with Hassaan
    // Pick a date for meeting 2 weeks in future.
    { Id: 11, Name: "Application Acquisition", Priority: 1, Disabled: false},
    { Id: 7, Name: "Schedule an Appointment / Demo", Priority: 1},
    // TODO: All account recovery steps are listed in insizon dotnet backend
    { Id: 10, Name: "Account Recovery", Priority: 1, Disabled: true},
    { Id: 9, Name: "How To Delete Account", Priority: 1},
    { Id: 8, Name: "Other", Priority: 1}
  ]

  public appPriceMin: Array<IContactUs_AppPriceRange> = [
    { Id: 1, Name: "$250,000"},
    { Id: 2, Name: "$500,000"},
    { Id: 3, Name: "$750,000"},
    { Id: 4, Name: "$1,000,000"},
    { Id: 5, Name: "$5,000,000"},
    { Id: 6, Name: "$10,000,000"},
    { Id: 7, Name: "$25,000,000"}
  ]

  // App Name
  public appNames: Array<IContactUs_AppNameOptions> = [];

  constructor(
    private companyService: CompanyService,
    private appService: AppManagementService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    // Initialize component
    this.getMeetingDate();
    this.getApps();
  }

  onSubmit() {
    if (this.isSubmitting) return
    if (!this.formData.email.includes('@')) {
      this.failedMsg = "Invalid email";
      this.showErrorMessage = true;
      setTimeout(() => { this.showErrorMessage = false }, 15000);
      return;
    }

    if (this.formData?.appMeeting) {
      const meetingTime: string = this.formData?.appMeeting.split("T")[1];
      const meetingTimeHr: string = meetingTime.split(":")[0];
      const validHr: Array<string> = ["06", "07", "08"];
      const isValidTime: boolean = validHr.includes(meetingTimeHr);
      if (!isValidTime) {
        this.failedMsg = "Invalid meeting time: Pick a time between 6am - 9am";
        this.showErrorMessage = true;
        setTimeout(() => { this.showErrorMessage = false }, 15000);
        return;
      }
    }

    this.isSubmitting = true;
    this.companyService.createContactUs({
      fullName: this.formData.fullName,
      email: this.formData.email,
      subject: Number(this.formData.subject),
      appNameInt: Number(this.formData.appNameInt),
      appPrice: this.formData.appPrice,
      appMeeting: this.formData.appMeeting,
      message: this.formData.message,
    }).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        this.showSuccessMessage = true;
        setTimeout(() => {
          this.showSuccessMessage = false;
          // Reset form
          this.formData = {
            fullName: "",
            email: "",
            subject: 1,
            message: "",
            appPrice: undefined,
            appMeeting: undefined,
            appNameInt: undefined
          }
         }, 5000);
      },
      error: (error: ICustomError) => {
        this.isSubmitting = false;
        this.failedMsg = error.error.msg;
        this.showErrorMessage = true;
        setTimeout(() => { this.showErrorMessage = false }, 15000);
      }
    });
  }

  // Utility methods for enhanced UX
  getCharacterCount(): number {
    return this.formData.message.length
  }

  isCharacterLimitNear(): boolean {
    return this.getCharacterCount() > 450; // Assuming 500 char limit
  }

  getCharacterLimitClass(): string {
    const count = this.getCharacterCount()
    if (count > 480) return "danger"
    if (count > 450) return "warning"
    return "normal"
  }

  dismissSuccessMessage() {
    this.showSuccessMessage = false
  }

  dismissErrorMessage() {
    this.showErrorMessage = false
  }

  // Contact methods
  callPhone() {
    window.open(`tel:${this.contactInfo.phone}`, "_self");
  }

  sendEmail(type = "general") {

  }

  openMap() {
    const address = encodeURIComponent(this.contactInfo.address);
    window.open(`https://maps.google.com/?q=${address}`, "_blank");
  }

  openSocialLink(link: any) {
    window.open(link.url, "_blank");
  }


  getMeetingDate() {
    // Get today's date
    const today = new Date();
    const dayInWeek: number = 7;
    // Set min a week from now
    today.setDate(today.getDate() + dayInWeek);
    this.minDate = this.formatDate(today, "06:00");

    const maxDateLimit = new Date();
    maxDateLimit.setDate(today.getDate() + dayInWeek * 12);
    this.maxDate = this.formatDate(maxDateLimit, "09:00");
  }


  private formatDate(date: Date, time: string): string {
    const year = date.getFullYear();
    // getMonth() is zero-based, so add 1
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T${time}`;
  }

  getApps() {
    this.appService.getAllApps()
    .subscribe({
      next: (response) => {
        this.appManagement = response.data;
        for (let i: number = 0; i < this.appManagement.length; i++) {
          this.appNames[i] = {
            Id: i + 1,
            Name: this.appManagement[i].title
          }
        }
      },
      error: () => {
        this.toastr.error("Failed to get apps");
      }
    });
  }
}
